var RootVariable = {
  BUTTON_ICON_SIZE: '--gui-button-icon-size',
  BUTTON_SINGLE_ICON_SIZE: '--gui-button-single-icon-size',
  BUTTON_ICON_MARGIN: '--gui-button-icon-margin',
  BUTTON_FONT_SIZE: '--gui-button-font-size',
  BUTTON_FONT_WEIGHT: '--gui-button-font-weight',
  BUTTON_HEIGHT: '--gui-button-h',
  BUTTON_RADIUS: '--gui-button-radius',
  BUTTON_BORDER: '--gui-button-border',
  BUTTON_BORDER_WIDTH: '--gui-button-border-width',
  BUTTON_BORDER_COLOR: '--gui-button-border-color',
  BUTTON_BG: '--gui-button-bg',
  BUTTON_COLOR: '--gui-button-color',
  BUTTON_ACTIVE_BORDER_COLOR: '--gui-button-active-border-color',
  BUTTON_ACTIVE_BG: '--gui-button-active-bg',
  BUTTON_ACTIVE_COLOR: '--gui-button-active-color',
  BUTTON_HOVER_BORDER_COLOR: '--gui-button-hover-border-color',
  BUTTON_HOVER_BG: '--gui-button-hover-bg',
  BUTTON_HOVER_COLOR: '--gui-button-hover-color',
  BUTTON_DISABLED_BORDER_COLOR: '--gui-button-disabled-border-color',
  BUTTON_DISABLED_BG: '--gui-button-disabled-bg',
  BUTTON_DISABLED_COLOR: '--gui-button-disabled-color',
  BUTTON_PADDING: '--gui-button-padding',
  BUTTON_LOADING_COLOR: '--gui-button-loading-color'
};

export { RootVariable };
//# sourceMappingURL=constant.js.map
